'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormField = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _listeners = require('../../utils/listeners');

var _functional = require('../../utils/functional');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var classes = {
  LABEL_TOP: 'frm-Field_Label-top',
  DATE_INPUT: 'frm-Field_Item-dateEdit',
  VALIDATE: 'frm-Field_Item-validate'
};

var selectors = {
  ITEM: '.js-FormField_Item',
  LABEL: '.js-FormField_Label'
};

var FormField = exports.FormField = function () {
  function FormField(el) {
    (0, _classCallCheck3.default)(this, FormField);

    this.el = el;
    this.els = this.getEls();

    this.init();
  }

  (0, _createClass3.default)(FormField, [{
    key: 'init',
    value: function init() {
      this.updateLabelStyle();
      this.setupListeners();
    }
  }, {
    key: 'setupListeners',
    value: function setupListeners() {
      this.listeners = new _listeners.Listeners();

      this.listeners.add(this.els.item, 'focus', this.updateStyle.bind(this));
      this.listeners.add(this.els.item, 'blur', this.updateStyle.bind(this));
      this.listeners.add(this.els.item, 'input', this.updateStyle.bind(this));
      this.listeners.add(this.els.item, 'keyup', this.updateStyle.bind(this));
    }
  }, {
    key: 'updateStyle',
    value: function updateStyle() {
      this.updateValidationState();
      this.updateLabelStyle();
    }
  }, {
    key: 'updateValidationState',
    value: function updateValidationState() {
      var inputValue = this.els.item.value;
      if (this.validated && inputValue !== '') {
        this.setValidate(false);
      }
    }
  }, {
    key: 'updateLabelStyle',
    value: function updateLabelStyle() {
      var labelTop = false;
      var dateInputted = false;
      var inputValue = this.els.item.value;
      var activeElement = this.els.item === document.activeElement;

      if (inputValue && inputValue !== '' || activeElement) {
        labelTop = true;

        if (this.els.item.type === 'date') {
          dateInputted = true;
        }
      }

      this.els.label.classList.toggle(classes.LABEL_TOP, labelTop);
      this.els.item.classList.toggle(classes.DATE_INPUT, dateInputted);
    }
  }, {
    key: 'setValidate',
    value: function setValidate(val) {
      this.els.item.classList.toggle(classes.VALIDATE, val);
    }
  }, {
    key: 'reset',
    value: function reset() {
      if (!this.els.item.dataset.defaultValue) {
        this.els.item.value = '';
      }
      this.setValidate(false);
    }
  }, {
    key: 'getEls',
    value: function getEls() {
      var context = this.el;

      return {
        item: (0, _functional.getElement)(selectors.ITEM, { context: context }),
        label: (0, _functional.getElement)(selectors.LABEL, { context: context })
      };
    }
  }, {
    key: 'validationMessages',
    get: function get() {
      return {
        empty: this.els.item.dataset.validationMessageEmpty,
        invalid: this.els.item.dataset.validationMessageInvalid
      };
    }
  }, {
    key: 'validated',
    get: function get() {
      return this.els.item.classList.contains(classes.VALIDATE);
    }
  }, {
    key: 'required',
    get: function get() {
      return this.els.item.required;
    }
  }, {
    key: 'value',
    get: function get() {
      return this.els.item.value;
    }
  }, {
    key: 'type',
    get: function get() {
      return this.els.item.type;
    }
  }]);
  return FormField;
}();